import { render, staticRenderFns } from "./AssignModal.vue?vue&type=template&id=2e344994&scoped=true&"
import script from "./AssignModal.vue?vue&type=script&lang=js&"
export * from "./AssignModal.vue?vue&type=script&lang=js&"
import style0 from "./AssignModal.vue?vue&type=style&index=0&id=2e344994&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e344994",
  null
  
)

export default component.exports